import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { PropType } from "vue";
import { Cell } from "../map/Cell";
import MapCellVoteSet from "@/components/map/cell/MapCellVoteSet.vue";
import Section from "@/components/Section.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MapCell',
  props: {
    cell: {
        type: Object as PropType<Cell>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Vertegenwoordigd in deze cel:", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cell.voteSets, (voteSet, index) => {
        return (_openBlock(), _createBlock(MapCellVoteSet, {
          key: index,
          "vote-set": voteSet
        }, null, 8, ["vote-set"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})